const emptyLineRegex = /<p>(<br>|\s+)<\/p>$/;
/**
 * Removes blank lines from the text.
 * @param text html string from Quill editor
 */
export const trimEmptyLines = (text) => {
    let trimmedTexted = `${text}`;
    while (emptyLineRegex.test(trimmedTexted)) {
        trimmedTexted = trimmedTexted.replace(emptyLineRegex, '');
    }
    return trimmedTexted;
};
/**
 * Removes <br> elements from the text.
 * @param text html string from Quill editor
 */
export const removeLineBreaks = (text) => {
    return text.replace(/<\/?br>/g, '');
};
